import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';

const ROUTE_LABELS = {
    '/stage-learning': '৩০ সেকশন',
    '/sentence-builder': 'বাক্য নির্মাণ',
    '/lesson': 'পাঠ',
    '/drills': 'অনুশীলন',
    '/spelling-builder': 'স্পেলিং',
    '/common-mistakes': 'সাধারণ ভুল',
    '/common-1200-words': 'Common 1200 Words',
};

const MobileBackNav = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const label = ROUTE_LABELS[pathname];

    if (!label || pathname === '/dashboard') return null;

    return (
        <div className="flex md:hidden items-center gap-2 px-3 pt-1 pb-2" data-testid="mobile-back-nav">
            <button
                onClick={() => navigate('/dashboard')}
                className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-600 transition-colors text-xs font-medium"
                data-testid="mobile-home-btn"
            >
                <Home className="w-3.5 h-3.5" />
                Home
            </button>
            <ArrowLeft className="w-3 h-3 text-slate-300" />
            <span className="text-xs font-medium text-slate-500 truncate" style={{ fontFamily: "'Tiro Bangla', serif" }}>{label}</span>
        </div>
    );
};

export default MobileBackNav;
